import AccountFilter from "../widgets/AccountFilter";
import SearchFilter from "../widgets/SearchFilter"
import { usePath } from "../../libs/path/PathProvider";
import _ from "lodash";
import Dropdown from "../../gui/Dropdown/Dropdown";
import { UpdateEvent } from "../../gui/GUIEvents";

export default function TaxToolbar(){
    const {query,setQuery} = usePath()
    const now = new Date().getFullYear()
    const years = _.range(now - 6, now+1).reverse()
    const year = parseInt(query.year as string) || now
    const onYear = (e:UpdateEvent<number>) => setQuery({year:e.value!})
    return <div className="toolbar flex middle gap-8">
        <AccountFilter/>
        <SearchFilter/>
        <Dropdown options={years} defaultValue={year} onUpdate={onYear} placeholder="Tax Year" float={true} anchorProps={{width:"match"}}/>
    </div>
}